import createCrudVuexModule from "@/store/crud";

export const organizationReceiverGroup = createCrudVuexModule({
  namespaced: true,
  path: "/receiver-group",
});
